import React, { useState } from 'react'
import { ContainerPontos } from '../../styled'
import ButtonCustom from '../../../../../../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
import { GeoPointFeature } from '../../../headerAnalises/components/modalNovaAnalise'

// Tipagem das props (opcional, se estiver usando TS)
interface PointsGridProps {
  initialPoints: GeoPointFeature[]
  inserirPontosSelecionados: Function
  id: string | number
  cod_analise: number
  removerPonto: (analiseId: string | number, pontoNome: number | string) => void
}

export const PontosAnalises: React.FC<PointsGridProps> = ({ initialPoints = [], inserirPontosSelecionados, id, cod_analise, removerPonto }) => {

  return (
    <ContainerPontos>
      <h3 className='points-title'>Pontos</h3>

      <div className='points-grid'>
        {initialPoints.map((point, index) => (
          <div
            key={index}
            className='point-card'
            style={{ backgroundColor: point?.COR }}
          >
            {point?.NOME.toString().padStart(2, '0')}{' '}
            {/* Garante 2 dígitos (07, 09...) */}
            <button
              className='point-card__remove'
              onClick={(e) => {
                e.stopPropagation()
                removerPonto(id, point?.NOME)
              }}
              title='Remover ponto'
            >
              <FontAwesomeIcon icon={faXmark} style={{ fontSize: '10px' }} />
            </button>
          </div>
        ))}

        <ButtonCustom
          style={{
            height: '35px',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          type='secondary'
          onClick={() => inserirPontosSelecionados(initialPoints, id, cod_analise)}
          icon={<FontAwesomeIcon icon={faPlus} />}
        />
      </div>
    </ContainerPontos>
  )
}
